import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';

export function setAguardando(aguardando) {
    return {
        type: 'DASHBOARD_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista(filtro) {
    return (dispatch, getState) => {
        dispatch(setAguardando(true));
		axios.post(`${consts.API_URL}/checklistResposta/dashboard`, {
            ...filtro,
            id_usuario: getState().auth.usuario.id
        }).then(result => {
			dispatch({
				type: 'DASHBOARD_LISTADO',
				payload: result
			});
            dispatch(setAguardando(false));
		}).catch(e => {
			console.log(e);
            dispatch(setAguardando(false));
		});
	}
}

export function getListaMetaVisita() {
    return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/metaVisita`).then(result => {
			dispatch({
				type: 'DASHBOARD_META_VISITA_LISTADO',
				payload: result
			});
		}).catch(e => {
			console.log(e);
		});
	}
}

export function getListaCliente() {
    const request = axios.get(`${consts.API_URL}/cliente/listarSelect`);
    return {
        type: 'DASHBOARD_CLIENTE_SELECT_LISTADO',
        payload: request
    };
}

export function getListaChecklist() {
    const request = axios.get(`${consts.API_URL}/checklist/listarSelect`);
    return {
        type: 'DASHBOARD_CHECKLIST_SELECT_LISTADO',
        payload: request
    };
}

export function getListaUsuario() {
    const request = axios.get(`${consts.API_URL}/usuario`);
    return {
        type: 'DASHBOARD_USUARIO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaGrupo() {
    const request = axios.get(`${consts.API_URL}/grupoCliente/listarSelect`);
    return {
        type: 'DASHBOARD_GRUPO_SELECT_LISTADO',
        payload: request
    };
}